import script from "./AiPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AiPanel.vue?vue&type=script&setup=true&lang=js"

import "./AiPanel.vue?vue&type=style&index=0&id=f2aeadde&scoped=true&lang=css"

import exportComponent from "F:\\work\\projects\\HiOmics\\Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2aeadde"]])

export default __exports__